
import { MachineComponentModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import Page from '@/Page.vue';
import { Component, Ref } from 'vue-property-decorator';
import { Guid } from '@/libs/common/functions/guid';
import { cloneDeep } from 'lodash';
import { machineComponentsStore } from '@/libs/machine-components/+state/store';

@Component({})
export default class MachineComponentDialog extends Page {
    dialog = false;
    loading = false;
    saving = false;
    deleting = false;
    deleteDialog = false;
    valid = false;
    id = '';

    machineComponent: MachineComponentModel | null = null;
    machineComponentOriginal: MachineComponentModel | null = null;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.id == Guid.EmptyGuid();
    }

    requiredRule(v: any) {
        return !!v || (this.$t('validation.requiredField') as any);
    }

    open(id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close() {
        this.dialog = false;
    }

    private load(): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadMachineComponent()
                    .then((e) => {
                        this.loading = false;
                        resolve(e);
                    })
                    .catch((e: any) => {
                        this.loading = false;
                        reject(e);
                    });
            });
        } else {
            this.machineComponent = {
                id: Guid.EmptyGuid(),
                code: '',
                name: '',
            } as MachineComponentModel;
            this.machineComponentOriginal = cloneDeep(this.machineComponent);
            return Promise.resolve();
        }
    }

    private loadMachineComponent() {
        return new Promise((resolve, reject) => {
            machineComponentsStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(machineComponentsStore, CrudReponse.Get)
                .then((e) => {
                    this.machineComponent = e;
                    this.machineComponentOriginal = cloneDeep(e);
                    resolve(e);
                })
                .catch((e: any) => {
                    reject(e);
                });
        });
    }

    private save() {
        if (this.form.validate()) {
            const machineComponent = { ...this.machineComponent };
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                machineComponentsStore.dispatch(CrudAction.Create, { item: machineComponent });
                this.subscribe(machineComponentsStore, CrudReponse.Create)
                    .then((e: MachineComponentModel) => {
                        this.machineComponent = e;
                        this.machineComponentOriginal = cloneDeep(e);
                        this.id = e.id!;
                        this.saving = false;
                        this.$emit('saved', this.machineComponent);
                        this.close();
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            } else {
                machineComponentsStore.dispatch(CrudAction.Update, { item: machineComponent });
                this.subscribe(machineComponentsStore, CrudReponse.Update)
                    .then((e: MachineComponentModel) => {
                        this.machineComponent = e;
                        this.machineComponentOriginal = cloneDeep(e);
                        this.saving = false;
                        this.$emit('saved', this.machineComponent);
                        this.close();
                    })
                    .catch((e) => {
                        this.saving = false;
                        throw e;
                    });
            }
        }
    }

    deleteClick() {
        this.deleteDialog = true;
    }

    deleteMachineComponent() {
        this.deleting = true;
        machineComponentsStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(machineComponentsStore, CrudReponse.Delete)
            .then(() => {
                this.deleting = false;
                this.deleteDialog = false;
                this.close();
            })
            .catch(() => {
                this.deleting = false;
            });
    }
}
